<template>
  <div :class="['wrapper', classes]">
    <header class="main-header">
      <a href="/" class="logo">
        <!-- mini logo for sidebar mini 40x50 pixels -->
        <span class="logo-mini">
          <img src="/static/img/suez-white.png" alt="Logo" class="img-responsive center-block"></span>
        <!-- logo for regular state and mobile devices -->
        <div class="logo-lg">
          <img src="/static/img/suez-white.png" alt="Logo" class="img-responsive">
        </div>
      </a>

      <!-- Header Navbar -->
      <nav class="navbar navbar-static-top" role="navigation">
        <!-- Navbar Right Menu -->
        <div class="navbar-custom-menu">
          <ul class="nav navbar-nav">

          </ul>
        </div>
      </nav>
    </header>
    <!-- Left side column. contains the logo and sidebar -->
    <sidebar :display-name="demo.displayName"
             :picture-url="demo.avatar" />

    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <section class="content-header">
        <h1>
          {{$route.name.toUpperCase() }}
          <small>{{ $route.meta.description }}</small>
        </h1>
        <ol class="breadcrumb">
          <li><a href="javascript:;"><i class="fa fa-home"></i></a></li>
          <li v-if="$route.meta.parent" class="active"><router-link :to="{name: $route.meta.parent.name}">{{$route.meta.parent.name.toUpperCase()}}</router-link></li>
          <li class="active">{{$route.name.toUpperCase()}}</li>
        </ol>
      </section>

      <router-view></router-view>
    </div>
    <!-- /.content-wrapper -->

  </div>
  <!-- ./wrapper -->
</template>

<script>
import faker from 'faker'
import { mapState } from 'vuex'
import config from '../config'
import Sidebar from './Sidebar'
import 'hideseek'

export default {
  name: 'Dash',
  components: {
    Sidebar,
  },
  data: function () {
    return {
      // section: 'Dash',
      year: new Date().getFullYear(),
/*       classes: {
        fixed_layout: config.fixedLayout,
        hide_logo: config.hideLogoOnMobile,
      }, */
      error: '',
    }
  },
  computed: {
    ...mapState([
      'userInfo',
    ]),
    demo () {
      return {
        displayName: faker.name.findName(),
        avatar: faker.image.avatar(),
        email: faker.internet.email(),
        randomCard: faker.helpers.createCard(),
      }
    },
  },
  methods: {
    changeloading () {
      this.$store.commit('TOGGLE_SEARCHING')
    },
  },
}
</script>

<style lang="scss">

@import '../scss/variables';

.skin-green .main-header .logo,
.skin-green .main-header .logo:hover {
  background-color:$suez-blue;
}

.wrapper {
  .main-header {
    position: fixed;
    background-color:transparent;
    width:auto;
    padding:15px 0;
    height:auto;
    a.logo-suez {
      background-color:$suez-blue;
    }
  }

  .content-wrapper {
    min-height: 100vh !important;
    background-color: $suez-grey !important;
  }

  .main-sidebar {
    position: fixed;
    height: 100vh;
    background-color:$suez-blue;
    padding-top:80px;
  }
}

.wrapper.hide_logo {
  @media (max-width: 767px) {
    .main-header .logo {
      display: none;
    }
  }
}

.logo-mini, .logo-lg {
  text-align: center;

}

.logo-lg {
  img {
    display: -webkit-inline-box;
    width:auto;
    max-height:40px;
  }
}
.user-panel {
  height: 4em;
}

hr.visible-xs-block {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.17);
  height: 1px;
  border-color: transparent;
}

.content-header {
  background-color:white !important;
}
</style>



// WEBPACK FOOTER //
// Dash.vue?04e9b878